import * as React from 'react'
import PropTypes from 'prop-types'

import Analytics from '../../../utils/Analytics'
import { CTALink, CTAButtonContainer } from './styles'

export default function CTAButton({
  children,
  ctaLink,
  ctaVariant = false,
  ctaAnalytics = 'Clicked_Builder CTA',
}) {
  return (
    <CTAButtonContainer ctaVariant={ctaVariant} onClick={() => Analytics.track(ctaAnalytics)}>
      <CTALink to={ctaLink} ctaVariant={ctaVariant}>
        {children}
      </CTALink>
    </CTAButtonContainer>
  )
}

CTAButton.propTypes = {
  ctaLink: PropTypes.string,
  ctaVariant: PropTypes.string,
  children: PropTypes.node,
  ctaAnalytics: PropTypes.string,
}
